<template>
  <div class="competition-rank-list-wrapper">
    <router-link
      v-if="!catchError"
      class="back"
      :to="{ name: 'Competition', params: $route.params }"
    >
      <img
        src="@/assets/icons/backArrow2.png"
        style="margin-right: 10px;"
        alt=""
      />
      {{ $t("competitions.tr.backToCompetition") }}
    </router-link>
    <router-link
      v-else
      class="back"
      :to="{ name: 'Home', params: { lang: $i18n.locale } }"
    >
      <img
        src="@/assets/icons/backArrow2.png"
        style="margin-right: 10px;"
        alt=""
      />
      {{ $t("competitions.tr.listVoting") }}
    </router-link>

    <h1>{{ $t("competitions.tr.backToCompetition") }}</h1>
    <div class="small-rank-list-wrapper">
      <img
        v-if="showLoader"
        :src="require('@/assets/images/loader.gif')"
        alt=""
        class="spiner-img"
      />
      <small-rank-list
        v-else
        v-for="(r, index) in rank"
        :key="index"
        :columns="getColumns"
        :rank="r"
        :num="index + 1"
        :archived="archived"
        :competition="competition"
        @checkVoter="checkSid(r)"
      />
    </div>
    <table>
      <tr>
        <th>{{ $t("competitions.tr.number") }}</th>
        <th v-for="(col, index) in getColumns" :key="index">
          {{ $t(col.label) }}
        </th>
        <th v-if="!archived && isWoting"></th>
      </tr>
      <tbody v-if="!showLoader">
        <tr v-for="(r, index) in rank" :key="index">
          <td>{{ index + 1 + "." }}</td>
          <td v-for="(col, i) in getColumns" :key="i">
            <a
              v-if="col.key === 'wrk_name' && r.work_file"
              :href="generateDownloadLink(r)"
            >
              {{ r[col.key] }}
            </a>
            <a
              v-else-if="col.key === 'wrk_name' && r.wrk_work"
              :href="generateLink(r)"
              target="_blank"
            >
              {{ r[col.key] }}
            </a>
            <a
              v-else-if="
                col.key === 'wrk_sponsor_name' &&
                  r.wrk_sponsor_name &&
                  r.wrk_sponsor_link
              "
              :href="generateSponsorLink(r)"
              target="_blank"
            >
              {{ r[col.key] }}
            </a>
            <a
              v-else-if="col.key === 'sch_name' && r.sch_website"
              :href="generateSchoolLink(r)"
              target="_blank"
            >
              {{ r[col.key] }}
            </a>
            <router-link
              v-else-if="col.key === 'sch_name' && !r.sch_website"
              :to="{ name: 'CompetitionNoSchool', params: $route.params }"
            >
              <span>{{ r[col.key] }}</span>
            </router-link>
            <span v-else>{{ r[col.key] }}</span>
          </td>
          <td v-if="!archived && isWoting">
            <div @click="checkSid(r)" class="btn">
              <img
                src="@/assets/icons/check.png"
                alt=""
                style="margin-right: 10px;"
              />
              {{ $t("competitions.tr.vote") }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showLoader" class="local-loader-wrapper">
      <img :src="require('@/assets/images/loader.gif')" alt="" />
    </div>
    <TurnStile
      action="giveVote"
      :resetToken="resetToken"
      @set-token="setToken"
    />
    <TurnStile
      action="checkVote"
      :resetToken="resetToken2"
      @set-token="setToken2"
    />
    <TurnStile
      action="checkSid"
      :resetToken="resetToken3"
      @set-token="setToken3"
    />
  </div>
</template>

<script>
import smallRankList from "@/components/smallRankList.vue";
import eventBus from "@/shared/eventBus.js";
import { api, baseURL } from "@/api";
import TurnStile from "@/components/TurnStileVue2.vue";

export default {
  name: "CompetitionRankList",
  components: {
    smallRankList,
    TurnStile
  },
  data() {
    return {
      localToken: "",
      localToken2: "",
      localToken3: "",
      resetToken: false,
      resetToken2: false,
      resetToken3: false,
      rank: [],
      age: null,
      vote: null,
      archived: false,
      competition: null,
      catchError: false,
      showLoader: false,
      disableBtn: false
    };
  },
  activated() {
    this.getCompetition();
    this.initFacebookSdk();
  },
  methods: {
    initFacebookSdk() {
      return new Promise(resolve => {
        // wait for facebook sdk to initialize before starting the vue app
        window.fbAsyncInit = () => {
          FB.init({
            appId: 904707426892630,
            cookie: true,
            xfbml: true,
            version: "v13.0"
          });
        };
        (function(d, s, id) {
          var js;
          var fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      });
    },
    async getCompetition() {
      this.rank = [];
      this.age = null;
      this.archived = false;
      this.competition = null;
      this.catchError = false;
      try {
        let params = {
          id: this.$route.params.id
        };
        this.showLoader = true;
        let res = await api.getCompetition(params);
        this.rank = res.data.rank_list;
        this.age = res.data.data.cmp_age;
        this.archived = res.data.data.cmp_archived === 1;
        this.competition = res.data.data;
        this.showLoader = false;
      } catch (e) {
        console.log(e);
        this.catchError = true;
        this.showLoader = false;
      }
    },
    async giveVote(work) {
      try {
        // await this.$recaptchaLoaded();
        // let token = await this.$recaptcha("giveVote");
        let params = {
          cmp_id: this.$route.params.id,
          token: this.localToken,
          sid: localStorage.sid,
          id: work.wrk_id
        };
        this.resetToken = !this.resetToken;
        let res = await api.giveVote(params);
        this.$toast.success(this.$t("competitions.tr.successVote"), {
          duration: 8000
        });
      } catch (e) {
        this.$toast.error(this.$t("competitions.tr.errVote"), {
          duration: 8000
        });
      } finally {
        this.getCompetition();
      }
    },
    openConfirmVoteModal(work, points) {
      let modalData = {
        // title: `Da li ste sigurni da želite da dodelite ${points} poena za rad:`,
        title:
          this.$t("competitions.tr.addPoints") +
          " " +
          points +
          this.$t("competitions.tr.forWork") +
          ":",
        workTitle: work.wrk_name,
        ok: () => {
          this.giveVote(work);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmVoteModal"
      };
      eventBus.$emit("openModal", params);
    },
    async checkVote(work) {
      try {
        // await this.$recaptchaLoaded();
        // let token = await this.$recaptcha("checkVote");
        let params = {
          cmp_id: this.$route.params.id,
          token: this.localToken2,
          fbToken: this.$store.state.fbToken,
          id: work.wrk_id
        };
        this.resetToken2 = !this.resetToken2;
        let res = await api.checkVote(params);
        if (res.data.sid) {
          localStorage.setItem("sid", res.data.sid);
        }
        if (res.data.points) {
          this.openConfirmVoteModal(work, res.data.points);
        }
      } catch (e) {
        if (e.response.data.message === "voted-for-work") {
          this.$toast.error(this.$t("competitions.tr.alreadyVoted"), {
            duration: 8000
          });
        } else if (e.response.data.message === "voted") {
          this.$toast.error(this.$t("competitions.tr.permit3time"), {
            duration: 8000
          });
        } else if (e.response.data.message === "invalid-fbToken") {
          this.$toast.error(this.$t("competitions.tr.notLogedinFb"), {
            duration: 8000
          });
        } else if (e.response.data.message === "try-later") {
          this.$toast.error(this.$t("competitions.tr.errFb"), {
            duration: 8000
          });
        }
      }
    },
    async checkSid(work) {
      if (this.disableBtn) {
        return;
      }
      this.disableBtn = true;
      setTimeout(() => {
        this.disableBtn = false;
      }, 4000);
      if (localStorage.sid) {
        try {
          // await this.$recaptchaLoaded();
          // let token = await this.$recaptcha("checkVote");
          let params = {
            cmp_id: this.$route.params.id,
            token: this.localToken3,
            sid: localStorage.sid,
            id: work.wrk_id
          };
          this.resetToken3 = !this.resetToken3;
          let res = await api.checkVote(params);
          if (res.data.points) {
            this.openConfirmVoteModal(work, res.data.points);
          }
        } catch (e) {
          if (e.response.data.message === "voted-for-work") {
            this.$toast.error(this.$t("competitions.tr.alreadyVoted"), {
              duration: 8000
            });
          } else if (e.response.data.message === "voted") {
            this.$toast.error(this.$t("competitions.tr.permit3time"), {
              duration: 8000
            });
          } else if (e.response.data.message === "invalid-fbToken") {
            this.checkVoter(work);
          } else if (e.response.data.message === "try-later") {
            this.$toast.error(this.$t("competitions.tr.errFb"), {
              duration: 8000
            });
          }
        }
      } else {
        this.checkVoter(work);
      }
    },
    async checkVoter(work) {
      if (!this.$store.state.fbToken) {
        const { authResponse } = await new Promise(FB.login);
        if (authResponse.accessToken) {
          this.$store.commit("setFbToken", authResponse.accessToken);
        } else {
          return;
        }
      }

      this.checkVote(work);
    },
    generateDownloadLink(work) {
      return baseURL + work.work_file;
    },
    generateLink(work) {
      return work.wrk_work;
    },
    generateSponsorLink(work) {
      return work.wrk_sponsor_link;
    },
    generateSchoolLink(work) {
      return work.sch_website;
    },
    setToken(e) {
      this.localToken = e;
    },
    setToken2(e) {
      this.localToken2 = e;
    },
    setToken3(e) {
      this.localToken3 = e;
    }
  },
  computed: {
    isWoting() {
      if (this.competition) {
        let now = new Date();
        let start = new Date(this.$moment.utc(this.competition.cmp_from_vote));
        let end = new Date(this.$moment.utc(this.competition.cmp_to_vote));
        if (now > start && now < end) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getColumns() {
      let res = [
        {
          key: "wrk_name",
          label: "competitions.columns.wrk_name"
        },
        {
          key: "votes",
          label: "competitions.columns.votes"
        },
        {
          key: "wrk_sponsor_name",
          label: "competitions.columns.wrk_sponsor_name"
        }
      ];

      if (this.age === 1) {
        res = [
          {
            key: "wrk_name",
            label: "competitions.columns.wrk_name"
          },
          {
            key: "votes",
            label: "competitions.columns.votes"
          },
          {
            key: "wrk_sponsor_name",
            label: "competitions.columns.wrk_sponsor_name"
          },
          {
            key: "wrk_class",
            label: "competitions.columns.wrk_sponsor_name.wrk_class1"
          },
          {
            key: "sch_name",
            label: "competitions.columns.sch_name"
          }
        ];
      } else if (this.age === 2 || this.age === 3) {
        res = [
          {
            key: "wrk_name",
            label: "competitions.columns.wrk_name"
          },
          {
            key: "votes",
            label: "competitions.columns.votes"
          },
          {
            key: "wrk_sponsor_name",
            label: "competitions.columns.wrk_sponsor_name"
          },
          {
            key: "wrk_class",
            label: "competitions.columns.wrk_class2"
          },
          {
            key: "sch_name",
            label: "competitions.columns.sch_name"
          }
        ];
      }

      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
.competition-rank-list-wrapper {
  margin: 0 auto;
  position: relative;
  max-width: 1320px;
  width: calc(100% - 40px);
  padding-top: 30px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .local-loader-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 150px;
    }
  }

  .small-rank-list-wrapper {
    display: none;
  }

  table,
  th,
  td {
    border: 1px solid;
    border-collapse: collapse;
    padding: 15px 10px;
  }
  table {
    width: 100%;
  }

  h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 52px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 0;
    margin-bottom: 10px;
  }
  p {
    font-weight: 400;
    font-size: 20px;
    line-height: 194.9%;
    margin-bottom: 20px;
  }

  .back {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    color: rgba(140, 140, 140, 0.96);
    cursor: pointer;
    text-decoration: none;
    margin-bottom: 50px;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
@media only screen and (max-width: 1024px) {
  .competition-rank-list-wrapper {
    table {
      display: none;
    }
    .small-rank-list-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;

      .spiner-img {
        width: 150px;
      }
    }
    h1 {
      text-align: center;
      width: 100%;
      margin-bottom: 20px;
    }
  }
}
</style>
